import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 45AA2B72-8538-41CB-BAD4-20C43E40D21C
 * name rss-off
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rss-off.svg
 * tags
 */
export const RssOffIcon = createSvgIcon(<><path d="M2.5,3.77L3.78,2.5L21.5,20.22L20.23,21.5L18.73,20H16.73C16.73,19.25 16.67,18.5 16.54,17.81L6.19,7.46C5.5,7.33 4.75,7.27 4,7.27V5.27L2.5,3.77M6.18,15.64A2.18,2.18 0 0,1 8.36,17.82C8.36,19 7.38,20 6.18,20C5,20 4,19 4,17.82A2.18,2.18 0 0,1 6.18,15.64M4,10.1A9.9,9.9 0 0,1 13.9,20H11.07A7.07,7.07 0 0,0 4,12.93V10.1M9.13,5.31C13.59,6.87 17.13,10.41 18.69,14.87L9.13,5.31Z" /></>, 'RssOffIcon');
export default RssOffIcon